import { useHistory } from 'react-router-dom';
import { Collection, DevBar } from '@eti/debug';
import { isDev } from '../../../common/debug/utils';
import { DebugCommonComponents } from '../../../common/debug/components';
import OrderLoginRedirection from './OrderLoginRedirection';
import SearchRedirection from './SearchRedirection';

const NewBrandRedirectionPage = () => {
  const history = useHistory();
  const redirectionType = history?.location?.state?.redirectionType;

  return (
    <>
      {redirectionType === 'order-login' ? <OrderLoginRedirection /> : <SearchRedirection />}
      {isDev && (
        <DevBar>
          <Collection>
            <DebugCommonComponents />
          </Collection>
        </DevBar>
      )}
    </>
  );
};

export default NewBrandRedirectionPage;
